import { styled, Typography } from '@chronosphereio/chrono-ui';
import { memo } from 'react';
import { ModeOption, UnitOptions } from '@/core';
import { SeriesMarker, TooltipSeriesLabel, TooltipSeriesRow } from '../PanelTooltip';
import { BarChartTooltipData } from './model';
import { formatDisplayValue } from './utils';

interface BarChartTooltipContentProps {
  data: BarChartTooltipData;
  unit?: UnitOptions;
  mode?: ModeOption;
  isCompareMode?: boolean;
  comparisonPeriodLabel?: string;
}

export const BarChartTooltipContent = memo(function BarChartTooltipContent({
  data,
  unit = { kind: 'Decimal' },
  mode = 'value',
  isCompareMode = false,
  comparisonPeriodLabel = 'Previous period',
}: BarChartTooltipContentProps) {
  return (
    <TooltipContentWrapper>
      {data.value !== undefined && data.value !== null && (
        <TooltipSeriesRow>
          {data.color && <SeriesMarker color={data.color} variant="solid" />}
          <TooltipSeriesLabel>{data.label}</TooltipSeriesLabel>
          <Typography variant="body2">{formatDisplayValue({ value: data.value, mode, unit })}</Typography>
        </TooltipSeriesRow>
      )}
      {isCompareMode && data.comparisonValue !== undefined && data.comparisonValue !== null && (
        <TooltipSeriesRow>
          {data.comparisonColor && <SeriesMarker color={data.comparisonColor} variant="striped" />}
          <TooltipSeriesLabel>
            {data.label} ({comparisonPeriodLabel})
          </TooltipSeriesLabel>
          <Typography variant="body2">{formatDisplayValue({ value: data.comparisonValue, mode, unit })}</Typography>
        </TooltipSeriesRow>
      )}
    </TooltipContentWrapper>
  );
});

const TooltipContentWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));
